import { render, staticRenderFns } from "./PreliminariIsregistravimas.vue?vue&type=template&id=0442ef48&scoped=true&"
import script from "./PreliminariIsregistravimas.vue?vue&type=script&lang=js&"
export * from "./PreliminariIsregistravimas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0442ef48",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VContainer})
